import React, { useCallback, useEffect } from 'react';
import { ChevronRight } from 'sushiweb/Icons';
import grey from 'sushiweb/tokens/color/grey';
import { helpNonPrimaryNodeShownEvent } from '../../analytics/events';
import { MetricsForJumboEvent } from '../../analytics/constants';

const ParentNode = ({
  orderId,
  node,
  getChildNodesToRender,
  setCurrentNodeParentId,
  callBack,
  setShowBack,
}) => {
  useEffect(() => {
    if (node?.node_type === 'root') {
      setShowBack(false);
    } else setCurrentNodeParentId(node?.parent_id);
    helpNonPrimaryNodeShownEvent({
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.feature_meta]: {
        node_id: node?.id,
        is_default_open: false,
      },
    });
  }, [callBack, node]);

  const callChildren = useCallback(() => {
    getChildNodesToRender(node?.id);
    setCurrentNodeParentId(node?.parent_id);
  }, [node, getChildNodesToRender]);
  return (
    <div
      className={`tw-flex  tw-w-full  tw-justify-between tw-bg-base-white  tw-cursor-pointer  tw-rounded-xl tw-py-4 tw-px-5  tw-text-200 tw-font-bold `}
      onClick={callChildren}
    >
      {node?.title}
      <ChevronRight size={14} color={grey.z700} />
    </div>
  );
};

export default ParentNode;
